import { render, staticRenderFns } from "./registerBonusModal.vue?vue&type=template&id=286a8352"
import script from "./registerBonusModal.vue?vue&type=script&lang=js"
export * from "./registerBonusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports